import { graphql } from "~/gql";
export const GET_RATES = graphql(/* GraphQL */ `
  query GetRates($filter: RateFilter!) {
    getRates(filter: $filter) {
      id
      type
      isLevelRate
      amount
      description
      feeEarner {
        id
      }
      feeEarnerLevel {
        id
        description
      }
      organisationalUnit {
        id
      }
    }
  }
`);
